(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["batch-liquid"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mokurra-variant-message')){
  customElements.define('mokurra-variant-message',class extends HTMLElement{
    async connectedCallback(){
      this.controller?.abort();
      const controller=new AbortController();this.controller=controller;
      try{
        const {StandardEvents}=await import('@shopify/events');
        if(controller.signal.aborted)return;
        this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect,event=>{
          if(!(event.target instanceof Element)||event.target.closest('product-card'))return;
          const request=(this.request||0)+1;this.request=request;
          event.promise?.then(({detail})=>{
            if(controller.signal.aborted||request!==this.request||!detail?.html)return;
            if(!detail.newProduct&&detail.productId&&String(detail.productId)!==this.dataset.productId)return;
            const next=[...detail.html.querySelectorAll('mokurra-variant-message')].find(el=>el.dataset.blockId===this.dataset.blockId);
            if(!next)return;
            this.innerHTML=next.innerHTML;
            this.hidden=next.hidden;
            this.setAttribute('style',next.getAttribute('style')||'');
            this.dataset.productId=next.dataset.productId;
          }).catch(()=>{});
        },{signal:controller.signal});
      }catch(error){console.warn('[mokurra-message]',error)}
    }
    disconnectedCallback(){this.controller?.abort()}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["promoend"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mokurra-promo-end')){
 customElements.define('mokurra-promo-end',class extends HTMLElement{
  connectedCallback(){
   clearTimeout(this.timer);
   const value=this.dataset.end||'';
   this.end=/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(value)?Date.parse(value):NaN;
   if(!Number.isFinite(this.end)){
    if(this.dataset.design==='true'){this.hidden=false;this.querySelector('span').textContent='Renseignez une date de fin valide dans les réglages du bloc.'}
    return;
   }
   try{
    const date=new Date(this.end),zone=this.dataset.zone||'Europe/London';
    const day=new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'long',timeZone:zone}).format(date);
    const time=new Intl.DateTimeFormat('en-GB',{hour:'numeric',minute:'2-digit',hour12:true,timeZone:zone}).format(date).replace(/\s/g,'').toLowerCase();
    this.querySelector('[data-promo-date]').textContent=day+', '+time;
    this.update();
   }catch(error){this.hidden=true}
  }
  update(){
   const remaining=this.end-Date.now();this.hidden=remaining<=0;
   if(remaining>0)this.timer=setTimeout(()=>this.update(),Math.min(remaining,60000));
  }
  disconnectedCallback(){clearTimeout(this.timer)}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["reviewstars"] && !Shopify.designMode) return;
  try {
    if (!window.mkrStoreRatingLinkInstalled) {
  window.mkrStoreRatingLinkInstalled = true;
  document.addEventListener('click', function(event) {
    const link = event.target.closest('a[data-mkr-review-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const hash = link.getAttribute('href');
    if (!hash || hash === '#') return;
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
    const target = document.getElementById(id) || document.getElementById('shopify-section-' + id);
    if (!target) return;
    event.preventDefault();
    let parent = target.parentElement;
    while (parent) {
      if (parent.tagName === 'DETAILS') parent.open = true;
      parent = parent.parentElement;
    }
    requestAnimationFrame(function() {
      const offset = Number(link.dataset.mkrOffset) || 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({top: Math.max(0, top), behavior: reduced ? 'instant' : 'smooth'});
      const temporaryTabindex = !target.hasAttribute('tabindex');
      if (temporaryTabindex) target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
      if (temporaryTabindex) target.addEventListener('blur', function() { target.removeAttribute('tabindex'); }, {once: true});
      try { history.pushState(null, '', hash); } catch {}
    });
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["stock-left"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mokurra-manual-stock')){
 customElements.define('mokurra-manual-stock',class extends HTMLElement{
  readRows(){
   try{this.rows=JSON.parse(this.querySelector('[data-stock-variants]')?.textContent||'[]')}catch{this.rows=[]}
  }
  normalizeId(id){return String(id||'').split('/').pop()}
  syncSelection(){
   this.readRows();
   const urlId=new URL(window.location.href).searchParams.get('variant');
   if(urlId&&this.setVariant(urlId))return;
   const scope=this.closest('.shopify-section, dialog')||document;
   const form=[...scope.querySelectorAll('product-form-component[data-product-id]')].find(el=>el.dataset.productId===this.dataset.productId);
   const formId=form?.querySelector('input[name="id"]')?.value;
   if(formId&&this.setVariant(formId))return;
   this.setVariant(this.dataset.selected);
  }
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();
   this.syncSelection();
   const scope=this.closest('.shopify-section, dialog')||document;
   scope.addEventListener('change',event=>{
    if(event.target?.name==='id'){this.readRows();this.setVariant(event.target.value)}
   },{signal:this.controller.signal});
   window.addEventListener('popstate',()=>this.syncSelection(),{signal:this.controller.signal});
   const signal=this.controller.signal;
   import('@shopify/events').then(({StandardEvents})=>{
    if(signal.aborted)return;
    scope.addEventListener(StandardEvents.productSelect,event=>{
     if(event.target instanceof Element&&event.target.closest('product-card'))return;
     const request=(this.request||0)+1;this.request=request;
     event.promise?.then(({detail})=>{
      if(signal.aborted||request!==this.request)return;
      const productId=detail?.productId;
      if(productId&&this.normalizeId(productId)!==this.dataset.productId)return;
      this.readRows();
      const id=detail?.resource?.id;
      if(id)this.setVariant(id);
     }).catch(()=>{});
    },{signal});
   }).catch(()=>{});
  }
  setVariant(id){
   const normalized=this.normalizeId(id);
   const row=this.rows?.find(item=>this.normalizeId(item.id)===normalized);
   if(!row)return false;
   const quantity=Math.max(0,Number(row.quantity)||0);
   const line=this.querySelector('[data-stock-line]');
   if(!line)return false;
   const green=row.green===true;
   const visible=row.available===true&&(green||quantity>0);
   line.hidden=!visible;
   line.dataset.status=green?'in-stock':'low-stock';
   this.querySelector('[data-stock-low]').hidden=green;
   this.querySelector('[data-stock-available]').hidden=!green;
   this.querySelector('[data-stock-count]').textContent=String(quantity);
   const hint=this.querySelector('[data-stock-hint]');if(hint)hint.hidden=visible;
   this.style.setProperty('--mkr-fill',(green?80:Math.min(80,Math.max(8,quantity*5)))+'%');
   const signature=normalized+':'+quantity+':'+green;
   if(visible&&signature!==this.signature){const fill=this.querySelector('[data-stock-fill]');if(fill){fill.style.animation='none';void fill.offsetWidth;fill.style.removeProperty('animation')}}
   this.signature=signature;
   return true;
  }
  disconnectedCallback(){this.controller?.abort()}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trustbadge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mokurra-klarna-cart')) {
  customElements.define('mokurra-klarna-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.button = this.querySelector('[data-mk-klarna-add]');
      this.error = this.querySelector('[data-mk-klarna-error]');
      this.button?.addEventListener('click', () => this.add(), { signal: this.abort.signal });
      this.amounts = JSON.parse(this.querySelector('[data-mk-instalments]')?.textContent || '{}');
      this.scope = this.closest('product-component, .product-details, .shopify-section');
      const refresh = () => {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.refreshAmount(), 100);
      };
      this.scope?.addEventListener('change', refresh, { signal: this.abort.signal });
      this.scope?.addEventListener('variant:update', refresh, { signal: this.abort.signal });
      this.refreshAmount();
    }
    refreshAmount() {
      const variantId = this.productForm()?.querySelector('[name="id"]')?.value;
      const amount = this.querySelector('[data-mk-instalment]');
      if (amount && this.amounts[variantId]) amount.textContent = this.amounts[variantId];
    }
    productForm() {
      const exact = document.getElementById(this.dataset.formId);
      if (exact) return exact;
      const scope = this.closest('product-component, .product-details, .shopify-section');
      if (!scope) return null;
      return Array.from(scope.querySelectorAll('form[action*="/cart/add"]')).find(form => {
        return form.querySelector('[name="product-id"]')?.value === this.dataset.productId;
      }) || null;
    }
    async add() {
      if (this.pending) return;
      const form = this.productForm();
      if (form && !form.reportValidity()) return;
      const body = form ? new FormData(form) : new FormData();
      if (!form) {
        body.set('id', this.dataset.variantId || '');
        body.set('quantity', '1');
      }
      if (this.error) this.error.hidden = true;
      if (!/^\d+$/.test(String(body.get('id') || ''))) {
        if (this.error) this.error.hidden = false;
        return;
      }
      if (!body.has('quantity')) body.set('quantity', '1');
      body.delete('sections');
      body.delete('sections_url');
      body.delete('return_to');
      this.pending = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          if (this.error) {
            if (typeof result.description === 'string') this.error.textContent = result.description;
            this.error.hidden = false;
          }
          return;
        }
        window.location.assign(this.dataset.cartUrl);
        this.redirecting = true;
      } catch (error) {
        if (this.error) this.error.hidden = false;
      } finally {
        if (!this.redirecting) {
          this.pending = false;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    }
    disconnectedCallback() {
      clearTimeout(this.refreshTimer);
      if (this.abort) this.abort.abort();
      this.abort = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trustbadgse"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mokurra-estimated-delivery-v2')) {
  customElements.define('mokurra-estimated-delivery-v2', class extends HTMLElement {
    connectedCallback() {
      this.updateDate();
      if (!this.refreshTimer) this.refreshTimer = setInterval(() => this.updateDate(), 60000);
    }
    updateDate() {
      const target = this.querySelector('[data-delivery-date]');
      if (!target) return;
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: this.dataset.timezone || 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      const get = type => Number(parts.find(part => part.type === type).value);
      const date = new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12));
      let remaining = Math.max(0, Math.min(60, Number(this.dataset.days) || 0));
      while (remaining > 0) {
        date.setUTCDate(date.getUTCDate() + 1);
        if (this.dataset.mode !== 'business' || (date.getUTCDay() !== 0 && date.getUTCDay() !== 6)) remaining--;
      }
      const options = { timeZone: 'UTC', day: 'numeric', month: 'short' };
      if (this.dataset.format !== 'short') options.weekday = 'short';
      target.textContent = new Intl.DateTimeFormat('en-GB', options).format(date);
      target.dateTime = date.toISOString().slice(0, 10);
    }
    disconnectedCallback() {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
